import { render } from "./ProductDescriptionEntryBewertungen.vue?vue&type=template&id=65647de2&scoped=true&ts=true"
import script from "./ProductDescriptionEntryBewertungen.vue?vue&type=script&lang=ts"
export * from "./ProductDescriptionEntryBewertungen.vue?vue&type=script&lang=ts"

import "./ProductDescriptionEntryBewertungen.vue?vue&type=style&index=0&id=65647de2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65647de2"]])

export default __exports__